import type { Finding, QuickWin } from '../../types/analysis.types';

export const vibeMapperStrengths: Finding[] = [
  {
    id: 'str1',
    title: 'HashiCorp Vault secrets management',
    description:
      'Production-grade secrets management with Vault Agent, AppRole auth, and JWT/OIDC for CI/CD and Kubernetes.',
  },
  {
    id: 'str2',
    title: 'End-to-end tests with Playwright',
    description: 'Comprehensive E2E test coverage for critical user flows with browser automation.',
  },
  {
    id: 'str3',
    title: 'Comprehensive CI pipeline',
    description: 'GitLab CI with build, test, and deployment stages across multiple sub-projects.',
  },
  {
    id: 'str4',
    title: 'Well-configured CLAUDE.md',
    description:
      'Detailed AI agent configuration with project context, architecture, common commands, and constraints.',
  },
  {
    id: 'str5',
    title: 'Infrastructure-as-code with Terraform',
    description:
      'All cloud infrastructure defined in Terraform modules with multi-environment support (dev/staging/prod).',
  },
];

export const vibeMapperGaps: Finding[] = [
  {
    id: 'gap1',
    title: 'No vulnerability scanning',
    description: 'Dependencies are not scanned for known CVEs. No Snyk, Trivy, or npm audit in CI.',
    severity: 'critical',
  },
  {
    id: 'gap2',
    title: 'No SAST tool configured',
    description:
      'No static application security testing to detect code-level vulnerabilities before deployment.',
    severity: 'high',
  },
  {
    id: 'gap3',
    title: 'No secret detection tool',
    description:
      'No Gitleaks or TruffleHog to prevent accidental credential commits. Risk of hardcoded secrets in history.',
    severity: 'high',
  },
  {
    id: 'gap4',
    title: 'No PR/MR template',
    description:
      'Merge requests lack a structured template for description, testing checklist, and reviewer guidance.',
    severity: 'high',
  },
  {
    id: 'gap5',
    title: 'No automated dependency updates',
    description:
      '240 of 370 dependencies are outdated (65% drift). No Dependabot or Renovate configured.',
    severity: 'medium',
  },
];

export const vibeMapperQuickWins: QuickWin[] = [
  {
    id: 'qw1',
    title: 'Implement SAST with SonarQube or Semgrep',
    description:
      'Add static analysis to GitLab CI to catch security vulnerabilities and code quality issues automatically.',
    effort: 'medium',
    impact: 'high',
  },
  {
    id: 'qw2',
    title: 'Enable secret detection with Gitleaks',
    description: 'Add Gitleaks pre-commit hook and CI stage to prevent accidental secret commits.',
    effort: 'low',
    impact: 'high',
  },
  {
    id: 'qw3',
    title: 'Add merge request template',
    description:
      'Create .gitlab/merge_request_templates/default.md with description, testing checklist, and review sections.',
    effort: 'low',
    impact: 'medium',
  },
];
